import React, { useState } from 'react'

import { Icon } from '../../components/Icon'

import UITabBar from '../../components/UI/UITabBar'

import { useAuth } from '../../context/AuthContext'

import TrainingCategories from '../training/TrainingCategories'
import SafeguardingCategories from '../safeguarding/SafeguardingCategories'
import Account from './Account'
import SchoolSettings from './SchoolSettings'
import Users from './Users'
import NotificationSettings from './NotificationSettings'


const Settings = () => {
  const { logout } = useAuth()
  const [activeTab, setActiveTab] = useState<string>('Account')

  const handlePressTab = (tab: string) => {
    setActiveTab(tab)
  }
  const renderTabContent = () => {
    switch (activeTab) {
      case 'Account':
        return <Account />
      case 'School Settings':
        return <SchoolSettings />
      case 'Users':
        return <Users />
      case 'Training Categories':
        return <TrainingCategories />
      case 'Safeguarding Categories':
        return <SafeguardingCategories />
      case 'Notifications':
        return <NotificationSettings />
      default:
        return null
    }
  }

  return (
    <div
      className={
        'flex flex-col gap-[20x] w-full bg-white  h-full rounded-3xl p-5 '
      }
    >
      <div
        style={{
          height: 'calc(100vh - 100px)',
          overflow: 'auto',
          scrollbarWidth: 'none',
        }}
      >
        <div className={'flex w-full justify-between items-start '}>
          <div className="flex-col w-[50%] gap-[20px]">
            <p className={'text-lg leading-6 text-text2 font-bold'}>Settings</p>
          </div>
          <div>
            <div
              onClick={() => logout()}
              className="gap-[10px]  bg-gray2 items-center justify-between min-w-[95px] text-white h-12 px-[20px] flex rounded-[72px] cursor-pointer"
            >
              <p className={'font-semibold text-sm text-text1 leading-6'}>
                Logout
              </p>
              <Icon
                name={'IconLogout'}
                strokeWidth={1}
                stroke={'#3487A2'}
                width={16}
                height={16}
              />
            </div>
          </div>
        </div>
        <UITabBar
          titles={[
            'Account',
            'School Settings',
            'Users',
            'Notifications',
            'Training Categories',
            'Safeguarding Categories',
          ]}
          activeTab={activeTab}
          onPressTab={handlePressTab}
          containerStyle="mt-4"
          activeTabText="text-text2"
        />
        {renderTabContent()}
      </div>
      {/* Add School Modal */}
    </div>
  )
}

export default Settings
